import React from 'react';
import { SelectableFilters, truncateAppliedFilters } from './SelectableFilters';
import { FilterComponentProps } from './types';

export type YesNoOption = 'Yes' | 'No';

type YesNoFilterValues = Record<YesNoOption, boolean>;

const defaultFilters: YesNoFilterValues = { Yes: false, No: false };

function renderValues(value: [string, boolean][]): string {
  return truncateAppliedFilters(value.filter(([, applied]) => applied).map(([label]) => label));
}

export const YesNoFilters: React.FC<FilterComponentProps> = ({ columnDef, onFilterChanged }) => (
  <SelectableFilters<YesNoOption, YesNoFilterValues>
    columnDef={columnDef}
    defaultFilters={defaultFilters}
    onFilterChanged={onFilterChanged}
    options={[
      ['Yes', 'Yes'],
      ['No', 'No'],
    ]}
    renderValues={renderValues}
  />
);
